import React from 'react';
import grid from  "../assets/about section grid.png";
import vikram from "../assets/vikram-photo.png";
import card from "../assets/about-section-rectangle.png";

const About = () => {
  return (
    <div className='about' id='about'>
      <div className='sec1-about'>
        <p className='head-about'>You are now entering my 'About me' section</p>
        <p className='tag-about'>1</p>
      </div>

      <div className='sec2-about'>
        <img src={grid}/>
        <div>
          <p className='p1-sec2About'>Innovation isn't just my skill;<br/><br/> it's my superpower!</p>
          <p className='p2-sec2About'>As a product designer, my mission is to merge form and function, creating intuitive and aesthetically pleasing products.</p>
        </div>
      </div>

      <div className='sec3-about'>
        <img src={vikram}/>
        <img src={card}/>
      </div>

      <div className='sec4-about'>
        <p className='p-heavy'>Hey! My name is Vikramaditya Datta and I’m a 21 year old designer based in New Delhi.</p>
        <p className='p-light'>I am also experienced in Pillaging and Witch hunting. </p>
      </div>
    </div>
  )
}

export default About;
